module.exports = __webpack_public_path__ + "media/images/Matrix_Dashboard_Icon-98136c43.png";